module.exports = __webpack_public_path__ + "img/24.eed85c4b.png";